const spacer = 8

export const defaultTheme = {
  colors: {
    primary: '#5aa3ff',
    primaryHover: '#80b8ff',
    primarySelected: '#1352a3',
    secondary: '#474747',
    secondaryHover: '#808080',
    secondarySelected: '#3B3B3C',

    white: '#fff',
    black: '#000',

    success: '#00B27C',
    warning: '#ffae00',
    danger: '#ff364e',

    gray900: '#131313',
    gray800: '#272727',
    gray700: '#3b3b3c',
    gray600: '#474747',
    gray500: '#636363',
    gray400: '#7f7f7f',
    gray300: '#9c9c9c',
    gray200: '#b8b8b8',
    gray100: '#d4d4d4',

    common: {
      white: '#fff',
      black: '#000',
    },

    gray: {
      100: '#d4d4d4',
      200: '#b8b8b8',
      300: '#9c9c9c',
      400: '#7f7f7f',
      500: '#636363',
      600: '#474747',
      700: '#3b3b3c',
      800: '#272727',
      900: '#131313',
    },
  },
  sizes: {
    form: {
      sm: `${3 * spacer}px`,
      md: `${4 * spacer}px`,
      lg: `${5 * spacer}px`,
    },
  },
}
